import { useContext } from 'react'

import { FlowContext } from './FlowContext'

export const useFlowContext = () => {
  return useContext(FlowContext)
}
